import {Component, OnInit, Input} from '@angular/core';
import {ModalNavigationComponent} from '../../../services/gui/modal/modal-navigation-component';
import {ScheduledCommercialDTO} from '../../../services/api/api';
import {ModalNavigationService} from '../../../services/gui/modal/modal-navigation.service';
import {UtilService} from '../../../services/util.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {BookingEditorService} from '../../../services/booking-editor/booking-editor.service';

@Component({
  selector: 'sb-comp-planning-commercial',
  templateUrl: './sb-planning-commercial.component.html',
  styleUrls: ['./sb-planning-commercial.component.scss'],
  standalone: false,
})
export class SbPlanningCommercialComponent implements OnInit, ModalNavigationComponent {
  @Input() submissions: ScheduledCommercialDTO[];

  blockBackdrop: boolean;
  isInModalContext: boolean;

  form: FormGroup;
  editMode: boolean;
  namingState: boolean;

  constructor(
    public modal: ModalNavigationService,
    public util: UtilService,
    public bookingEditorService: BookingEditorService
  ) {
    this.editMode = false;
    this.namingState = false;
    this.submissions = [];
    this.form = new FormGroup({
      Name: new FormControl('', Validators.required),
      Description: new FormControl(''),
    });
  }

  get Name() {
    return this.form.get('Name');
  }

  get Description() {
    return this.form.get('Description');
  }

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.submissions = this.modal.getCurrentNavigation().data.submissions;
      this.editMode = true;
    }
  }

  ok() {
    if (this.isInModalContext) {
      if (this.editMode && !this.namingState) {
        this.namingState = true;
      } else if (this.editMode && this.namingState) {
        this.modal.result({ name: this.Name.value, description: this.Description.value });
      }
    }
  }

  cancel() {
    if (this.isInModalContext) {
      this.modal.result(null);
    }
  }

  deleteCommercial(i: number) {
    if (i <= this.submissions.length) {
      for (const record of this.bookingEditorService.eventStore.allRecords) {
        if (record['data']?.commercial?.id === this.submissions[i].id) {
          record.set('inCard', false);
          break;
        }
      }
      this.submissions.splice(i, 1);
    }
    if (this.submissions.length === 0) {
      this.cancel();
    }
  }
}
